import {
  ContentCopy,
  Delete,
  SmartButton
} from "@mui/icons-material";
import React, { memo } from "react";

import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { Typography } from "@mui/material";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        padding: "16px",
        borderRadius: "12px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
        border: '1px solid #e5e7eb',
        minWidth: '280px',
        maxWidth: '320px',
        position: 'relative'
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: "#3b82f6",
          width: "12px",
          height: "12px",
          top: "50%",
          left: "-6px",
          cursor: 'pointer',
          border: '2px solid white'
        }}
        onConnect={params => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      />

      <div style={{
        display: "flex",
        position: "absolute",
        right: 12,
        top: 12,
        cursor: "pointer",
        gap: 8
      }}>
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ width: "16px", height: "16px", color: "#9ca3af", '&:hover': { color: '#3b82f6' } }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ width: "16px", height: "16px", color: "#9ca3af", '&:hover': { color: '#ef4444' } }}
        />
      </div>

      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '12px'
      }}>
        <SmartButton sx={{ width: "18px", height: "18px", color: "#8b5cf6" }} />
        <div style={{
          color: "#111827",
          fontSize: "14px",
          fontWeight: 600
        }}>
          Menu de Botões
        </div>
      </div>

      <div style={{ color: "#6b7280", fontSize: "11px", marginBottom: '8px' }}>
        {data.message?.substring(0, 50)}...
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
        {data.buttons && Array.isArray(data.buttons) && data.buttons.map((button, index) => (
          <div
            key={index}
            style={{
              backgroundColor: "#f9fafb",
              padding: "8px",
              borderRadius: "6px",
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              position: 'relative'
            }}
          >
            <SmartButton sx={{ color: "#8b5cf6", width: "16px", height: "16px" }} />
            <Typography
              sx={{
                textOverflow: "ellipsis",
                fontSize: "11px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                color: "#6b7280",
                flex: 1
              }}
            >
              {button.displayText}
            </Typography>
            <Handle
              type="source"
              position="right"
              id={"button_" + index}
              style={{
                background: "#3b82f6",
                width: "10px",
                height: "10px",
                right: "-5px",
                cursor: 'pointer',
                border: '2px solid white'
              }}
              isConnectable={isConnectable}
            />
          </div>
        ))}
      </div>

      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "#3b82f6",
          width: "12px",
          height: "12px",
          top: "50%",
          right: "-6px",
          cursor: 'pointer',
          border: '2px solid white'
        }}
        isConnectable={isConnectable}
      />
    </div>
  );
});
